import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OrderDetails from './OrderDetails';
import './Orders.scss';
import { getFilteredOrders, getOrders, setActiveTab, setCurrentOrder, updateOrder } from '../../Reducers/actions/ordersActions';
import { capitalizeFirstLetter } from '../../../helpers/utilities';
import UpdateOrder from '../../components/UpdateOrder/UpdateOrder';
import CircleNone from '../../components/CircleNone/CircleNone';
import { setTopNavbar } from '../../Reducers/actions/navbarActions';
import Icon from '../../components/Icon/Icon';
import { fromCentsToPounds } from '../../../helpers/money';
import { useNavigate } from 'react-router-dom';

const tabs = ['all', 'pending', 'shipped', 'completed'];


const Orders = () => {
  const userId = useSelector(state => state.auth?.user?.user_id);
  const { orders, loading, error, activeTab, currentOrder, orders_is_fetched } = useSelector(state => ({
    orders_is_fetched: !!state.orders.orders,
    orders: getFilteredOrders(state),
    loading: state.orders.loading,
    error: state.orders.error,
    activeTab: state.orders.activeTab,
    currentOrder: state.orders.currentOrder,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    dispatch(setTopNavbar({
      title: 'MY SALES',
      back: true,
    }))
  }, []);

  useEffect(() => {
    if (!orders_is_fetched) {
      dispatch(getOrders());
    }
  }, [userId, dispatch, orders_is_fetched]);

  // Filter orders based on active tab
  const filteredOrders = orders.filter(order => {
    if (activeTab === 'all') return true;
    return order.order_status.toLowerCase() === activeTab.toLowerCase();
  });

  const handleViewDetails = (order) => {
    dispatch(setCurrentOrder(order));
    navigate(`/orders/${order.order_id}`);
  };





  const handleSetActiveTab = (tab) => {
    dispatch(setActiveTab(tab));
  };




  if (loading) {
    return (
      <div className="orders">
        <div className="loading">
          LOADING...
        </div>
      </div>
    );
  }

  return (
    <div className="orders">


      {error && (
        <div className="error">
          <p>Error loading orders. Please try again later.</p>
          <p className="details">{error}</p>
        </div>
      )}


      {!orders_is_fetched ? (
        <div className="d-flex f-column aic jcc no-messages px-16 mt-40 pt-40">
          <Icon alias={'unboxing'} color={'#FF3232'} width={200} height={200} />
          <p className="fs-sm2 fg-crea fw-medium-bold mt-40 mb-16">No orders for now</p>
          <p className="fg-hyk-grey">Once someone buys a creation, their order will show up here. Keep creating!</p>
        </div>
      ) : (
        <Fragment>
          <div className="tabs-sales">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`tab ${tab.toLowerCase()}${activeTab === tab ? ' active' : ''}`}
                onClick={() => handleSetActiveTab(tab)}
              >
                {capitalizeFirstLetter(tab)// todo : this is not needed text transform handle that 
                }
              </button>
            ))}
          </div>
          <div className="list">

            {filteredOrders.length === 0 ?
              (<div className="d-flex f-column aic jcc pt-50 mt$50">
                <p className="fs-xs fg-dark fw-bold mt-40">No {activeTab} orders for now</p>
                <p className="fg-grey7 fs-xs fw-medium">Your {activeTab} orders will appear here</p>
              </div>)
              : filteredOrders.map((order) => (
                <div key={order.order_id} className="order-item">
                  <div className="content-orders">
                    <div className="main">
                      <div>
                        <h2>{order.creation?.title}</h2>
                        <div className="info">
                          <span className="customer">
                            {order.customer?.userName}
                          </span>
                          <span className="dot">•</span>
                          <span className="date">
                            {new Date(order.created_at).toLocaleString("fr-FR", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            }
                          </span>
                        </div>
                      </div>
                      <div className="orderprice">
                        {fromCentsToPounds(order?.baseAmountInCents || 0)}
                      </div>
                    </div>
                    <div className="status-row">
                      <span className={"status"}>
                        <span className={`dot ${order.order_status.toLowerCase()}`}></span>
                        {capitalizeFirstLetter(order.order_status)}
                      </span>
                      <button
                        className="view-details"
                        onClick={() => handleViewDetails(order)}>
                        Track
                      </button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Fragment>
      )}



    </div>
  );
};

export default Orders; 
